module.exports = __webpack_public_path__ + "img/maker_fair.9f87f968.png";